module.exports = __webpack_public_path__ + "img/zh_CN.7d40353.jpg";